<template>
    <app-button secondary :text="$t('cancel')" @click.prevent="$emit('click')" />
</template>

<script>
export default {
    name: 'AppButtonCancel'
};
</script>
